import React from "react";
// Component Library
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
import Dropdown from "@acadia-ui/dropdown";
import Modal from "@acadia-ui/modal";
import Badge from "@acadia-ui/badge";

const PrismaPackageTypeModal = ({ modalId, isProgrammatic, toggleProgramatic, handleNext }) => {
	return (
		<Modal
			id={modalId}
			heading="Add Package"
			description="Choose package type, and the system will refresh"
			onClick={() => {}}
			actionSetProps={{
				actionsRight: (
					<>
						<Button
							display={BUTTON_DISPLAY.SECONDARY}
							onClick={() => {
								toggleProgramatic(false);
								Modal.hide("package-type-modal");
							}}
							data-tracking-id-alt="cancel-package-type"
						>
							Cancel
						</Button>
						<Button
							onClick={() => {
								Modal.hide("package-type-modal");
								handleNext();
							}}
							data-tracking-id-alt="package-type-next-step"
						>
							Next
						</Button>
					</>
				)
			}}
		>
			<>
				<Dropdown
					isRequired={true}
					options={[
						{ label: "Standard", value: "Standard" },
						{ label: "Programmatic", value: "Programmatic" }
					]}
					value={isProgrammatic ? { label: "Programmatic", value: "Programmatic" } : { label: "Standard", value: "Standard" }}
					onChange={(selected) => toggleProgramatic(selected.value === "Programmatic")}
				>
					Package Type
				</Dropdown>

				{isProgrammatic && (
					<Badge size={"small"} icon="icon-action-item">
						Please ensure the correct package type has been selected. Prisma Programmatic Packages are not standard and may not push to all ad servers
					</Badge>
				)}
			</>
		</Modal>
	);
};
export default PrismaPackageTypeModal;
